import react from '../../assets/icons/react.svg'
//import python from '../../assets/icons/python.svg'

const languages = [
    {
        icon: react,
        name: 'HTML',
        level: '90'
    },
    {
        icon: react,
        name: 'CSS',
        level: '80'
    },
    {
        icon: react,
        name: 'JS',
        level: '70'
    },
    {
        icon: react,
        name: 'Wordpress',
        level: '84'
    },
    {
        icon: react,
        name: 'AJAX',
        level: '70'
    },
    {
        icon: react,
        name: 'Bootstrap',
        level: '80'
    },
    {
        icon: react,
        name: 'React JS',
        level: '50'
    }
]

const tools = [
    {
        icon: react,
        name: 'Photoshop',
        level: '70'
    },
    {
        icon: react,
        name: 'Illustrator',
        level: '60'
    },
    {
        icon: react,
        name: 'Web Tool',
        level: '80'
    },
    {
        icon: react,
        name: 'Figma',
        level: '45'
    },

]

export { tools, languages }